const menuItems = {
  items: [
    {
      id: 'pages',
      type: 'group',
      icon: 'icon-pages',
      children: [
        {
          id: 'dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/admin/dashboard',
          icon: 'feather icon-home',
          image: 'Dashboard.png'
        },
        {
          id: 'clientManagement',
          title: 'Client Management',
          type: 'item',
          url: '/admin/client-management',
          icon: 'feather icon-users',
          image: 'Manage Auditors.png'
        },
        {
          id: 'manageAuditors',
          title: 'Manage Auditors',
          type: 'item',
          url: '/admin/manage-auditors',
          icon: 'feather icon-users',
          image: 'Manage Auditors.png'
        },
        {
          id: 'ibpReference',
          title: 'IBP Reference Master',
          type: 'item',
          url: '/admin/ibp-reference',
          icon: 'feather icon-file-text',
          image: 'IBPReference.png'
        },
        {
          id: 'manageTemplates',
          title: 'Manage Templates',
          type: 'item',
          url: '/admin/manage-templates',
          icon: 'feather icon-book',
          image: 'Questionnaire.png'
        },
        {
          id: 'myChapters',
          title: 'My Sections',
          type: 'item',
          url: '/admin/my-chapters',
          icon: 'feather icon-package',
          image: 'Mysection.png'
        },
        {
          id: 'manageSites',
          title: 'Audit',
          type: 'item',
          url: '/admin/manage-sites',
          icon: 'feather icon-map-pin',
          image: 'Audit.png'
        },
        {
          id: 'auditReports',
          title: 'Audit Reports',
          type: 'item',
          url: '/admin/audit-reports',
          icon: 'feather icon-file-text',
          image: 'Audit Reports.png'
        },
        {
          id: 'subscription',
          title: 'Manage Subscription',
          type: 'item',
          url: '/admin/subscription',
          icon: 'feather icon-credit-card',
          image: 'Managesubscription.png'
        },
        {
          id: 'manageDelegateRole',
          title: 'Manage Delegate Role',
          type: 'item',
          url: '/admin/manage-delegate-role',
          icon: 'feather icon-shield',
          image: 'ManageDelegate.png'
        },
        {
          id: 'supportTickets',
          title: 'Support Ticket',
          type: 'item',
          url: '/admin/support-tickets',
          icon: 'feather icon-help-circle',
          image: 'SupportTicket.png'
        },
        {
          id: 'helpTutorials',
          title: 'Help & Tutorials',
          type: 'item',
          url: '/admin/help-tutorials',
          icon: 'feather icon-help-circle',
          image: 'helpSupportImg.png'
        },
        {
          id: 'aiDocuments',
          title: 'Ask AI Documents',
          type: 'item',
          url: '/admin/ai-documents',
          icon: 'feather icon-file',
          image: 'Aibot.png'
        },
        {
          id: 'auditLog',
          title: 'Audit Log',
          type: 'item',
          url: '/admin/audit-log',
          icon: 'feather icon-list',
          image: 'Settings.png'
        },
        {
          id: 'aiAssistant',
          title: 'AI Assistant',
          type: 'item',
          url: '/admin/ai-assistant',
          icon: 'feather icon-message-circle',
          image: 'Aibot.png'
        },
        {
          id: 'settings',
          title: 'Settings',
          type: 'item',
          url: '/admin/settings',
          icon: 'feather icon-settings',
          image: 'Settings.png'
        },
        {
          id: 'logout',
          title: 'Logout',
          type: 'item',
          url: '#',
          icon: 'feather icon-log-out',
          image: 'Logout.png'
        }
      ]
    }
  ]
};

export default menuItems;
